import yup from 'core/utils/validators';
import { FIELD_ALPHA_NUMERIC_SYMBOLS, FIELD_REQUIRED, getMinLength } from 'const';

const { object, string } = yup;

const alphaNumericAndSymbolsRegExp = /^[0-9a-zA-Z\[\],./\\]+$/; // eslint-disable-line no-useless-escape

export const permanentAddressFormSchema = () =>
  object().shape({
    registration_residential_type: string().required(FIELD_REQUIRED),
    registration_state_code: string().required(FIELD_REQUIRED),
    registration_pin_code: string().required(FIELD_REQUIRED).validateMinLength({
      from: 0,
      to: 6,
    }),
    registration_district: string().min(2, getMinLength(2)).required(FIELD_REQUIRED),
    registration_street: string().min(2, getMinLength(2)).required(FIELD_REQUIRED),
    registration_house: string().required(FIELD_REQUIRED),
    registration_address: string(),
    registration_flat: string().matches(alphaNumericAndSymbolsRegExp, FIELD_ALPHA_NUMERIC_SYMBOLS),
  });
